(() => {
  if (window.qnProductActionsReady) return;
  window.qnProductActionsReady = true;
  const cards = document.querySelectorAll('.qn-product[data-qn-title]');
  if (!cards.length || typeof HTMLDialogElement === 'undefined') return;
  const dialog = document.createElement('dialog');
  dialog.className = 'qn-quick-dialog';
  dialog.setAttribute('aria-labelledby','qn-quick-title');
  dialog.innerHTML = '<button type="button" class="qn-quick-close" aria-label="Close product preview">×</button><div class="qn-quick-layout"><div class="qn-quick-photo"><img alt=""></div><div class="qn-quick-copy"><p class="qn-quick-eyebrow">A closer look</p><h2 id="qn-quick-title"></h2><p class="qn-quick-selection"></p><p class="qn-quick-price"></p><p class="qn-quick-description"></p><a class="qn-quick-details">View full product details →</a><form class="qn-quick-add" method="post"><input type="hidden" name="id"><input type="hidden" name="quantity" value="1"><button type="submit">Add to cart</button></form><a class="qn-quick-options">Choose options</a></div></div>';
  document.body.append(dialog);
  const closeButton = dialog.querySelector('.qn-quick-close');
  const addForm = dialog.querySelector('.qn-quick-add');
  const options = dialog.querySelector('.qn-quick-options');
  let opener;
  cards.forEach(card => card.querySelector('.qn-quick-view')?.removeAttribute('hidden'));
  document.addEventListener('click', event => {
    const trigger = event.target.closest('.qn-quick-view');
    if (!trigger) return;
    const card = trigger.closest('.qn-product'), data = card.dataset;
    const url = new URL(data.qnUrl, location.origin);
    if (!['https:','http:'].includes(url.protocol)) return;
    opener = trigger;
    dialog.querySelector('h2').textContent = data.qnTitle;
    dialog.querySelector('.qn-quick-price').textContent = data.qnPrice;
    dialog.querySelector('.qn-quick-selection').textContent = data.qnOption || '';
    dialog.querySelector('.qn-quick-description').textContent = 'See the full product page for materials, sizing, gift details and available options.';
    const image = dialog.querySelector('img'); image.src = data.qnImage; image.alt = data.qnTitle;
    const photoStyle = getComputedStyle(card.querySelector('.qn-product__picture img'));
    image.style.maskImage = photoStyle.maskImage;
    image.style.webkitMaskImage = photoStyle.webkitMaskImage;
    image.style.maskSize = image.style.webkitMaskSize = 'contain';
    image.style.maskPosition = image.style.webkitMaskPosition = 'center';
    image.style.maskRepeat = image.style.webkitMaskRepeat = 'no-repeat';
    dialog.querySelector('.qn-quick-details').href = url.href;
    options.href = url.href;
    const direct = data.qnDirect === 'true' && data.qnAvailable === 'true';
    addForm.hidden = !direct; options.hidden = direct;
    options.textContent = data.qnAvailable === 'true' ? 'Choose options' : 'View product details';
    addForm.action = (window.Shopify?.routes?.root || '/') + 'cart/add';
    addForm.querySelector('[name=id]').value = data.qnVariant;
    dialog.showModal(); document.documentElement.classList.add('qn-modal-open'); closeButton.focus();
  });
  closeButton.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
  dialog.addEventListener('close', () => { document.documentElement.classList.remove('qn-modal-open'); if (opener?.isConnected) opener.focus(); });
})();
